__webpack_require__.p = "https://universal-login.dev.scentregroup.io/";